"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationModel = void 0;
const BaseModel_1 = require("./base/BaseModel");
const types_cerberus_1 = require("@journeyapps-platform/types-cerberus");
class IntegrationModel extends BaseModel_1.BaseModel {
    get model() {
        return this.options.model;
    }
    getProperties() {
        return this.model.properties;
    }
    org() {
        return this.options.banks.orgBank.org(this.model.org_id);
    }
    getOrg() {
        return this.options.banks.orgBank.resolve(this.model.org_id);
    }
    async regenerateSetupUrl() {
        const res = await this.options.clients.provisionCerberusClient().regenerateSetupUrl({
            id: this.model.id
        });
        return res.setup_url;
    }
    async delete() {
        await this.options.clients.provisionCerberusClient().deleteIntegration({
            id: this.model.id
        });
        const org = await this.getOrg();
        org.loadIntegrations();
    }
    async getParents() {
        return [await this.getOrg()];
    }
    async getResourceSelector() {
        const parents = await this.getParentResourceSelectors();
        return {
            id: this.model.id,
            model: 'integration',
            ...(parents.length > 0
                ? {
                    parents: parents
                }
                : {})
        };
    }
    async getComparativeResource() {
        return {
            scope: this.model.org_id,
            selector: await this.getResourceSelector()
        };
    }
}
exports.IntegrationModel = IntegrationModel;
